<bl-modal-content #content
  [title]="'顧客・車両情報の紐付け'"
  [disableOkButton]="_disableOkButton"
>
  <div body>
    <div class="web-reserve-content-title">Web予約内容</div>
    <table class="table">
      <thead>
        <tr>
          <th>お客様名</th>
          <th>フリガナ</th>
          <th>連絡先</th>
          <th>メールアドレス</th>
          <th>車両登録番号</th>
          <th>メーカー ／ 車種</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span>{{ _customerName }}</span></td>
          <td><span>{{ _customerKanaName }}</span></td>
          <td><span>{{ _contactTelInformation }}</span></td>
          <td><span>{{ _contactEmailInformation }}</span></td>
          <td><span>{{ _dispNumberPlate }}</span></td>
          <td><span>{{ _vehicleName }}{{ _vehicleModelFullWName }}</span></td>
        </tr>
      </tbody>
    </table>
    <div class="customer-vehicle-candidate-title">Web予約情報と紐付ける登録済みの顧客情報を下記から選択してください。</div>
    <div>
      <bl-reference-grid #refGrid
        [gridOptions]="_gridOptions"
        [gridHeight]="'_gridHeight'"
        [headerHeight]="_gridHeaderHeight"
        [rowHeight]="_gridRowHeight"
        [isOperable]="false"
        [totalCount]="_totalCount"
        [pageSizePatterns]="_gridSizePatterns"
        [showHeaderBtn]="_isHeaderBtn"
        [headerBtnText]="_headerBtnText"
        (headerBtnClickEvent)="onClickAdd()"
        (onReady)="onReadyGrid()"
        (changePageSize)="onChangePageSize($event)"
        (selectedRowEvent)="onSelectedRow($event)"
      >
      </bl-reference-grid>
      <div *ngIf="_isSelectMax" class="select-max">
        <span>{{ _tooManyResultsMessage  }}</span>
        <button *ngIf="_isSelectMaxBtn" type="button"
                class="btn btn-default"
                (click)="onSelectMax()"
        >{{ _selectMaxSize }}件表示
        </button>
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-customer-vehicle-link/web-reserve-customer-vehicle-link.component.html